"use strict";

import $ from "jquery";
window.$ = window.jQuery = $;
import 'slick-carousel'

export class ReadMore {
    constructor() {
        console.log("ReadMore module");

        $(".js-cta__readmore").on('click', function(){
            var item = $(this).closest('.js-readmore__item').find('p');
            console.log(item);
            if($(item).hasClass('fixedHeight')) {
                $(item).removeClass('fixedHeight')
            } else {
                $(item).addClass('fixedHeight')
            }
        });
    }
}